module.exports = __webpack_public_path__ + "static/media/digital-user-experience.ed29ddf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital-user-experience.png
// module id = 935
// module chunks = 0